import { setupRichTextElement } from '@/utils';

const richTextMixin = {
  methods: {
    mixinSetupRichTextElement() {
      this.$nextTick(() => {
        setupRichTextElement(this.$el);
      });
    },
  },
};

export default richTextMixin;
